import React from "react";
import CommonTextField from "../../../components/CommonTextField";
import { CountryStateSelect } from "src/features/auth/components/CountryStateSelect";

interface BusinessFormProps {
  formData: any;
  handleChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  setFormData: React.Dispatch<React.SetStateAction<any>>;
}

const BusinessForm: React.FC<BusinessFormProps> = ({ formData, handleChange, setFormData }) => {
  const handleCountryChange = (value: string) => {
    setFormData((prev: any) => ({
      ...prev,
      country: value,
      state: "",
    }));
  };

  const handleStateChange = (value: string) => {
    setFormData((prev: any) => ({
      ...prev,
      state: value,
    }));
  };

  return (
    <div className="p-6 grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-4">
      {/* LEFT COLUMN */}
      <CommonTextField label="User Name" name="user_name" value={formData.user_name} onChange={handleChange} disabled />
      <CommonTextField label="Name" name="name" value={formData.name} onChange={handleChange} />

      <CommonTextField label="Organization Name" name="organization_name" value={formData.organization_name} onChange={handleChange} disabled />
      <CommonTextField label="Organization Arabic Name" name="org_arabic_name" value={formData.org_arabic_name} onChange={handleChange} />

      <CommonTextField label="Business type" name="business_type" value={formData.business_type} onChange={handleChange} disabled />
      <CommonTextField label="Email ID" name="email_id" type="email" value={formData.email_id} onChange={handleChange} />

      <CommonTextField label="Date of Birth" name="date_of_birth" value={formData.date_of_birth} onChange={handleChange} />
      <CommonTextField label="Phone Number" name="phone_number" value={formData.phone_number} onChange={handleChange} />

      {/* FULL WIDTH */}
      <div className="md:col-span-2">
        <CommonTextField label="Address" name="address_line_1" value={formData.address_line_1} onChange={handleChange} fullWidth multiline rows={2} />
      </div>

      <CommonTextField label="Business Location" name="business_location" value={formData.business_location} onChange={handleChange} />
      <CommonTextField label="Time Zone" name="time_zone" value={formData.time_zone} onChange={handleChange} />

      {/* ✅ COUNTRY + STATE aligned like normal fields */}
      <div
        className="md:col-span-2 flex flex-col md:flex-row md:flex-wrap gap-4
  [&_.MuiInputBase-root]:border 
  [&_.MuiInputBase-root]:border-gray-300 
  [&_.MuiInputBase-root]:rounded-md
  [&_.MuiInputBase-root]:px-3
  [&_.MuiInputBase-root]:py-2
  [&_.MuiInput-underline:before]:hidden
  [&_.MuiInput-underline:after]:hidden"
      >
        <div className="w-full md:w-[48%]">
          <CountryStateSelect selectedCountry={formData.country} selectedState={formData.state} onCountryChange={handleCountryChange} onStateChange={handleStateChange} />
        </div>

        <div className="w-full md:w-[48%] mt-4">
          <CommonTextField
            label="Postal Code"
            name="postal_code"
            value={formData.postal_code}
            onChange={handleChange}
            fullWidth
            className="h-10 [&_.MuiInputBase-root]:h-12 [&_.MuiOutlinedInput-input]:py-2 [&_.MuiInput-underline:before]:border-b-0 [&_.MuiInput-underline:after]:border-b-0"
          />
        </div>
      </div>
    </div>
  );
};

export default BusinessForm;
